// Collapses Postmark's raw event list (which includes internal noise like
// SubscriptionChanged) into one plain-language summary a non-technical admin can read.
// Priority: a bounce always wins (most actionable), then Opened, then Delivered.
// Shared by EmailHistory.js and the per-participant Email History section on
// ParticipantEdit.js — both fetch the same shape from /communication-history's
// status endpoints and should render identically.
export const summarizeStatus = (events = [], fallbackStatus) => {
  const bounce = events.find((ev) => /bounce/i.test(ev.Type || ""));
  if (bounce) {
    return { badge: "Bounced", className: "status-badge--bounced", text: "This email address doesn't exist or rejected the message." };
  }
  if (events.some((ev) => ev.Type === "Opened")) {
    return { badge: "Opened", className: "status-badge--opened", text: "The recipient opened this email." };
  }
  if (events.some((ev) => ev.Type === "Delivered")) {
    return { badge: "Delivered", className: "status-badge--delivered", text: "Successfully delivered to the recipient's inbox." };
  }
  return { badge: fallbackStatus || "Sent", className: "status-badge--neutral", text: "Sent — delivery not yet confirmed." };
};
